import colors from "assets/styles/colors";

export default {
    labelSuccessBg: colors.accentGreen,
    labelSuccessColor: "white",

    labelAlertBg: colors.accentRed,
    labelAlertColor: "white",

    labelWarningBg: colors.accentOrange,
    labelWarningColor: "white",

    labelPrimaryBg: colors.darkAccentBlue,
    labelPrimaryColor: "white",

    labelSecondaryBg: colors.darkThemeMain,
    labelSecondaryColor: "white",
};
